import {WebFormModel} from "capitalist-shared/src/core/model";
import {Account} from '@/models/finance/account';
import {RemoteRequestState} from '@/backoffice/components/pages/taxrules/taxrules';
import {PaymentCodeEnum} from "capitalist-shared/src/finance/payments";
import httpAxiosApi from "capitalist-shared/src/core/axios.errors.handle";
const IndiaBanksImpsPaymentForm = () =>  import("@/components/forms/payout/forms/banks/asia/IndiaBanksImpsPaymentForm.vue");
const SepaPaymentForm = () => import("@/components/forms/payout/forms/sepa/SepaPaymentForm.vue");
const SpayzIndonesiaBanksPaymentForm
  = () => import("@/components/forms/payout/forms/banks/asia/SpayzIndonesiaBanksPaymentForm.vue");
const SouthKoreaBanksPaymentForm
  = () => import("@/components/forms/payout/forms/banks/asia/SouthKoreaBanksPaymentForm.vue");
const ThailandBanksPaymentForm
  = () => import("@/components/forms/payout/forms/banks/asia/ThailandBanksPaymentForm.vue");
const MalaysiaBanksPaymentForm
  = () => import("@/components/forms/payout/forms/banks/asia/MalaysiaBanksPaymentForm.vue");

const IndonesiaBanksPaymentForm
  = () => import("@/components/forms/payout/forms/epay/IndonesiaBanksPaymentForm.vue");
const IndiaBanksPaymentForm = () => import("@/components/forms/payout/forms/epay/IndiaBanksPaymentForm.vue");
const PagsmileMexicoSpeiPaymentForm
  = () => import("@/components/forms/payout/forms/pagsmile/mexico/PagsmileMexicoSpeiPaymentForm.vue");

const AfricaKenyaMobilePaymentForm = () => import("@/components/forms/payout/forms/africa/bank/AfricaKenyaMobilePaymentForm.vue");
const AfricaGhanaMobilePaymentForm = () => import("@/components/forms/payout/forms/africa/bank/AfricaGhanaMobilePaymentForm.vue");
const AfricaTanzaniaMobilePaymentForm = () => import("@/components/forms/payout/forms/africa/bank/AfricaTanzaniaMobilePaymentForm.vue");
const AfricaCameroonMobilePaymentForm = () => import("@/components/forms/payout/forms/africa/bank/AfricaCameroonMobilePaymentForm.vue");
const AfricaUgandaMobilePaymentForm = () => import("@/components/forms/payout/forms/africa/bank/AfricaUgandaMobilePaymentForm.vue");
const AfricaGhanaBanksPaymentForm
  = () => import("@/components/forms/payout/forms/africa/bank/AfricaGhanaBanksPaymentForm.vue");
const AfricaNigeriaBanksPaymentForm
  = () => import("@/components/forms/payout/forms/africa/bank/AfricaNigeriaBanksPaymentForm.vue");

const PagsmileBoliviaBankPaymentForm
  = () => import("@/components/forms/payout/forms/pagsmile/PagsmileBoliviaBankPaymentForm.vue");

const PagsmileCostaRicaBankPaymentForm = () =>
  import("@/components/forms/payout/forms/pagsmile/PagsmileCostaRicaBankPaymentForm.vue");
const PagsmileChileBankPaymentForm
  = () => import("@/components/forms/payout/forms/pagsmile/PagsmileChileBankPaymentForm.vue");
const PagsmilePeruBankPaymentForm
  = () => import("@/components/forms/payout/forms/pagsmile/PagsmilePeruBankPaymentForm.vue");
const PagsmileEcuadorBankPaymentForm = () => import("@/components/forms/payout/forms/pagsmile/PagsmileEcuadorBankPaymentForm.vue");

const PagsmileChileWalletPaymentForm = () => import("@/components/forms/payout/forms/pagsmile/PagsmileChileWalletPaymentForm.vue");
const ZalopayPaymentForm = () => import( "@/components/forms/payout/forms/epay/ZalopayPaymentForm.vue");
const GCashPaymentForm = () => import("@/components/forms/payout/forms/epay/GCashPaymentForm.vue");
const BkashPaymentForm = () => import("@/components/forms/payout/forms/epay/BkashPaymentForm.vue");
const PagsmileColombianTransfiyaPaymentForm = () => import("@/components/forms/payout/forms/pagsmile/colombia/PagsmileColombianTransfiyaPaymentForm.vue");
const PagsmileColombianBankPaymentForm = () =>
  import("@/components/forms/payout/forms/pagsmile/colombia/PagsmileColombianBankPaymentForm.vue");
const PagsmileColombianWalletPaymentForm
  = () => import("@/components/forms/payout/forms/pagsmile/colombia/PagsmileColombianWalletPaymentForm.vue");
const PagsmileColombianTpagaPaymentForm = () => import("@/components/forms/payout/forms/pagsmile/colombia/PagsmileColombianTpagaPaymentForm.vue");
const PagsmileColombianNequiPaymentForm = () => import("@/components/forms/payout/forms/pagsmile/colombia/PagsmileColombianNequiPaymentForm.vue");

const PagsmileBrazilianBankPaymentForm = () =>
  import("@/components/forms/payout/forms/pagsmile/PagsmileBrazilianBankPaymentForm.vue");
const PayoneerPaymentForm = () => import("@/components/forms/payout/forms/emoney/PayoneerPaymentForm.vue");

const SbpPaymentForm = () => import("@/components/forms/payout/forms/sbp/SbpPaymentForm.vue");
const YotaPaymentForm = () => import("@/components/forms/payout/forms/mobile/YotaPaymentForm.vue");

const WorldcardsEuroPaymentForm = () => import("@/components/forms/payout/forms/cards/worldcards/WorldcardsEuroPaymentForm.vue");
const WorldcardsUsdPaymentForm = () => import("@/components/forms/payout/forms/cards/worldcards/WorldcardsUsdPaymentForm.vue");

const GeorgianCardsPaymentForm = () => import("@/components/forms/payout/forms/cards/GeorgianCardsPaymentForm.vue");

const ArgentineBanksPaymentForm = () => import("@/components/forms/payout/forms/banks/ArgentinaBanksPaymentForm.vue");
const BrazilianPixPaymentForm = () => import("@/components/forms/payout/forms/banks/BrazilPixPaymentForm.vue");
const ColobianBanksPaymentForm = () => import("@/components/forms/payout/forms/banks/ColombiaBanksPaymentForm.vue");
const MexicanBanksPaymentForm = () => import("@/components/forms/payout/forms/banks/MexicanBanksPaymentForm.vue");

const TurkeyCardsPaymentForm = () => import("@/components/forms/payout/forms/cards/TurkishCardsPaymentForm.vue");
const WirePaymentForm = () => import("@/components/forms/payout/forms/wire/WirePaymentForm.vue");
const CapitalistInternalPaymentForm
  = () => import("@/components/forms/payout/forms/capitalist/CapitalistInternalPaymentForm.vue");
const UnionpayPaymentForm = () => import( "@/components/forms/payout/forms/cards/UnionpayPaymentForm.vue");
const UkrainianCardsPaymentForm = () => import("@/components/forms/payout/forms/cards/UkrainianCardsPaymentForm.vue");
const WorldcardsPaymentForm = () => import("@/components/forms/payout/forms/cards/worldcards/WorldcardsPaymentForm.vue");

const Card2cardPaymentForm = () => import("@/components/forms/payout/forms/cards/Card2cardPaymentForm.vue");
// const Card2cardPaymentForm = () => import("../../../../components/forms/payout/forms/cards/Card2cardPaymentForm.vue");
const RussianCardsPaymentForm = () => import("@/components/forms/payout/forms/cards/RussianCardsPaymentForm.vue");
const WebmoneyPaymentForm = () => import("@/components/forms/payout/forms/emoney/WebmoneyPaymentForm.vue");
const CapitalistChequePaymentForm = () =>
  import("@/components/forms/payout/forms/capitalist/CapitalistChequePaymentForm.vue");
const Tele2PaymentForm = () => import("@/components/forms/payout/forms/mobile/Tele2PaymentForm.vue");
const BeelinePaymentForm = () => import("@/components/forms/payout/forms/mobile/BeelinePaymentForm.vue");
const MegafonPaymentForm = () => import("@/components/forms/payout/forms/mobile/MegafonPaymentForm.vue");
const UkrainianMobilePaymentForm
  = () => import("@/components/forms/payout/forms/mobile/UkrainianMobilePaymentForm.vue");
const TmobilePaymentForm = () => import("@/components/forms/payout/forms/mobile/TmobilePaymentForm.vue");

const MtsPaymentForm = () => import("@/components/forms/payout/forms/mobile/MtsPaymentForm.vue");
const EthereumPaymentForm = () => import("@/components/forms/payout/forms/crypto/EthereumPaymentForm.vue");
const BitcoinPaymentForm = () => import("@/components/forms/payout/forms/crypto/BitcoinPaymentForm.vue");
const SngCardsPaymentForm = () => import("@/components/forms/payout/forms/cards/SngCardsPaymentForm.vue");
const CapitalistCardTopupPaymentForm = () => import( "@/components/forms/payout/forms/capitalist/CapitalistCardTopupPaymentForm.vue");
const YoomoneyPaymentForm = () => import("@/components/forms/payout/forms/emoney/YoomoneyPaymentForm.vue");
const QiwiPaymentForm = () => import("@/components/forms/payout/forms/emoney/QiwiPaymentForm.vue");
const SkrillPaymentForm = () => import("@/components/forms/payout/forms/SkrillPaymentForm.vue");
const NetellerPaymentForm = () => import("@/components/forms/payout/forms/NetellerPaymentForm.vue");
const PayTMPaymentForm = () => import("@/components/forms/payout/forms/PayTMPaymentForm.vue");
const IMPSPaymentForm = () => import("@/components/forms/payout/forms/IMPSPaymentForm.vue");
const UsdtPaymentForm = () => import("@/components/forms/payout/forms/crypto/UsdtPaymentForm.vue");
const UsdcPaymentForm = () => import("@/components/forms/payout/forms/crypto/UsdcPaymentForm.vue");
const KzCardsPaymentForm = () => import("@/components/forms/payout/forms/cards/KzCardsPaymentForm.vue");

const UzCardsPaymentForm = () => import("@/components/forms/payout/forms/cards/UzCardsPaymentForm.vue");

const AzerbaijaniCardsPaymentForm = () => import("@/components/forms/payout/forms/cards/AzCardsPaymentForm.vue");


export class TestWebapiPayoutModel extends WebFormModel {
  values: { fromAccount: string, destAccount: string, amount: string }
    = {fromAccount: '', destAccount: '', amount: ''}

  loadingModel: RemoteRequestState = new RemoteRequestState();

  loadModel(system = 'rucards') {
    this.loadingModel.loadStart();
    return httpAxiosApi.post('/webapi/finance/payout', {
      call: 'loadModel',
      system,
    }).then((result) => {
      this._setData(result.data.model);

      this.options.accounts = this.options.accounts.map((obj) => Account.createFromData(obj));
      this.loadingModel.loadEnd();
      return result.data.model;
    }).catch((err) => {
      this.loadingModel.loadError();
      throw err;
    });
  }
}


export const paymentFormsConfig = {
  [PaymentCodeEnum.Tele2]: Tele2PaymentForm,
  [PaymentCodeEnum.Beeline]: BeelinePaymentForm,
  [PaymentCodeEnum.Megafon]: MegafonPaymentForm,
  [PaymentCodeEnum.TinkoffMobile]: TmobilePaymentForm,
  [PaymentCodeEnum.Mts]: MtsPaymentForm,
  [PaymentCodeEnum.Yota]: YotaPaymentForm,
  [PaymentCodeEnum.Ethereum]: EthereumPaymentForm,
  [PaymentCodeEnum.Bitcoin]: BitcoinPaymentForm,
  [PaymentCodeEnum.SngCards]: SngCardsPaymentForm,
  [PaymentCodeEnum.CardsTopUp]: CapitalistCardTopupPaymentForm,
  [PaymentCodeEnum.YandexMoney]: YoomoneyPaymentForm,
  [PaymentCodeEnum.Payoneer]: PayoneerPaymentForm,
  [PaymentCodeEnum.Papara]: () => import("@/components/forms/payout/forms/emoney/PaparaPaymentForm.vue"),
  [PaymentCodeEnum.BangladeshBkash]: BkashPaymentForm,
  [PaymentCodeEnum.GCash]: GCashPaymentForm,
  [PaymentCodeEnum.ZaloPay]: ZalopayPaymentForm,
  [PaymentCodeEnum.Qiwi]: QiwiPaymentForm,
  [PaymentCodeEnum.Skrill]: SkrillPaymentForm,
  [PaymentCodeEnum.Neteller]: NetellerPaymentForm,
  [PaymentCodeEnum.PayTM]: PayTMPaymentForm,
  [PaymentCodeEnum.IMPS]: IMPSPaymentForm,
  [PaymentCodeEnum.USDT]: UsdtPaymentForm,
  [PaymentCodeEnum.USDC]: UsdcPaymentForm,
  [PaymentCodeEnum.KazakhstanCards]: KzCardsPaymentForm,
  [PaymentCodeEnum.UkrainianMobile]: UkrainianMobilePaymentForm,
  [PaymentCodeEnum.CapitalistCheque]: CapitalistChequePaymentForm,
  [PaymentCodeEnum.Webmoney]: WebmoneyPaymentForm,
  [PaymentCodeEnum.RussianCards]: RussianCardsPaymentForm,
  [PaymentCodeEnum.Sbp]: SbpPaymentForm,
  [PaymentCodeEnum.Card2Card]: Card2cardPaymentForm,
  [PaymentCodeEnum.Cards]: WorldcardsPaymentForm,
  [PaymentCodeEnum.WorldCardsEuro]: WorldcardsEuroPaymentForm,
  [PaymentCodeEnum.WorldCardsUsd]: WorldcardsUsdPaymentForm,
  [PaymentCodeEnum.UkrainianCards]: UkrainianCardsPaymentForm,
  [PaymentCodeEnum.UnionPay]: UnionpayPaymentForm,
  [PaymentCodeEnum.Capitalist]: CapitalistInternalPaymentForm,
  [PaymentCodeEnum.Wire]: WirePaymentForm,
  [PaymentCodeEnum.SEPA_EUR]: SepaPaymentForm,
  [PaymentCodeEnum.UzbekistanCards]: UzCardsPaymentForm,
  [PaymentCodeEnum.AzerbaijanCards]: AzerbaijaniCardsPaymentForm,
  [PaymentCodeEnum.GeorgiaCards]: GeorgianCardsPaymentForm,
  [PaymentCodeEnum.TurkeyCards]: TurkeyCardsPaymentForm,

  // [PaymentCodeEnum.AfricaBanks]: AfricaBanksPaymentForm,
  // [PaymentCodeEnum.AfricaMobile]: AfricaMobilePaymentForm,
  [PaymentCodeEnum.AFRICA_BANKS_GHANA]: AfricaGhanaBanksPaymentForm,
  [PaymentCodeEnum.AFRICA_BANKS_NIGERIA]: AfricaNigeriaBanksPaymentForm,
  [PaymentCodeEnum.AFRICA_MOMO_KENYA]: AfricaKenyaMobilePaymentForm,
  [PaymentCodeEnum.AFRICA_MOMO_GHANA]: AfricaGhanaMobilePaymentForm,
  [PaymentCodeEnum.AFRICA_MOMO_TANZANIA]: AfricaTanzaniaMobilePaymentForm,
  [PaymentCodeEnum.AFRICA_MOMO_CAMEROON]: AfricaCameroonMobilePaymentForm,
  [PaymentCodeEnum.AFRICA_MOMO_UGANDA]: AfricaUgandaMobilePaymentForm,

  [PaymentCodeEnum.ArgentinaBanks]: ArgentineBanksPaymentForm,
  [PaymentCodeEnum.BrazilPix]: BrazilianPixPaymentForm,
  [PaymentCodeEnum.ColombiaBanks]: ColobianBanksPaymentForm,
  [PaymentCodeEnum.MexicoBanks]: MexicanBanksPaymentForm,

  [PaymentCodeEnum.PAGS_PERU_BANK]: PagsmilePeruBankPaymentForm,
  [PaymentCodeEnum.PAGS_ECUADOR_BANK]: PagsmileEcuadorBankPaymentForm,
  [PaymentCodeEnum.PAGS_BOLIVIAN_BANK]: PagsmileBoliviaBankPaymentForm,
  [PaymentCodeEnum.INDIA_BANKS]: IndiaBanksPaymentForm,
  [PaymentCodeEnum.INDONESIA_BANKS]: IndonesiaBanksPaymentForm,
  [PaymentCodeEnum.PAGS_COSTA_RICA_BANK]: PagsmileCostaRicaBankPaymentForm,
  [PaymentCodeEnum.PAGS_BRBANK]: PagsmileBrazilianBankPaymentForm,
  // [PaymentCodeEnum.PAGS_BRPIX]: PagsmileBrazilianPixPaymentForm,
  [PaymentCodeEnum.PAGS_COLOMBIA_WALLET]: PagsmileColombianWalletPaymentForm,
  [PaymentCodeEnum.PAGS_COWALLET_TPAGA]: PagsmileColombianTpagaPaymentForm,
  [PaymentCodeEnum.PAGS_COWALLET_NEQUI]: PagsmileColombianNequiPaymentForm,

  [PaymentCodeEnum.PAGS_COLOMBIA_BANK]: PagsmileColombianBankPaymentForm,
  [PaymentCodeEnum.PAGS_COLOMBIA_TRANSFIYA]: PagsmileColombianTransfiyaPaymentForm,
  [PaymentCodeEnum.PAGS_CHILE_WALLET]: PagsmileChileWalletPaymentForm,
  [PaymentCodeEnum.PAGS_MXSPEI]: PagsmileMexicoSpeiPaymentForm,
  [PaymentCodeEnum.PAGS_CHILE_BANK]: PagsmileChileBankPaymentForm,

  [PaymentCodeEnum.MALAYSIA_BANKS]: MalaysiaBanksPaymentForm,
  [PaymentCodeEnum.SOUTH_KOREA_BANKS]: SouthKoreaBanksPaymentForm,
  [PaymentCodeEnum.THAILAND_BANKS]: ThailandBanksPaymentForm,
  [PaymentCodeEnum.INDONESIA_BANKS_SP]: SpayzIndonesiaBanksPaymentForm,
  [PaymentCodeEnum.IMPS_SP_INDIA_BANKS]: IndiaBanksImpsPaymentForm,
  // [PaymentCodeEnum.INDONESIA_BANKS]: SpayzIndonesiaBanksPaymentForm,
}
